import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { useMemo } from 'react';
export const requestFetchPersonalizationVariants = ({
  contentId
}) => http.get(`cospages/v2/landing-pages/${contentId}/personalized-variants`);
const fetchPersonalizationVariantsQuery = registerQuery({
  fieldName: 'personalizationVariants',
  args: ['contentId'],
  fetcher: requestFetchPersonalizationVariants
});
export const useFetchPersonalizationVariants = (contentId, shouldFetchData = true) => {
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(fetchPersonalizationVariantsQuery, {
    variables: {
      contentId
    },
    skip: !shouldFetchData
  });
  return useMemo(() => ({
    personalizationVariants: (data === null || data === void 0 ? void 0 : data.personalizationVariants) || [],
    error,
    loading,
    refetch
  }), [data, error, loading, refetch]);
};